//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      showMenu: false
    }
  },

  computed: {
    activeItem() {
      return (
        this.items.find((item) =>
          this.$route.path.startsWith(this.localePath(item.url))
        ) || null
      )
    }
  },

  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    }
  }
}
